import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SupplierPageLayout from '../components/SupplierPageLayout';
import SupplierStatusBadge from '../components/SupplierStatusBadge';
import SupplierEmptyState from '../components/SupplierEmptyState';
import {
  SupplierPoSummary,
  listSupplierOrders,
} from '../services/supplierApi';

const STATUS_FILTERS = [
  { value: '', label: 'All' },
  { value: 'PENDING_SUPPLIER', label: 'Pending' },
  { value: 'SUPPLIER_PROPOSED', label: 'Proposed' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'DISPATCHED', label: 'Dispatched' },
  { value: 'RECEIVED', label: 'Received' },
];

const POList: React.FC = () => {
  const [status, setStatus] = useState('');
  const [orders, setOrders] = useState<SupplierPoSummary[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    listSupplierOrders(status || undefined)
      .then((data) => setOrders(data.orders ?? []))
      .catch((e: Error) => setError(e.message))
      .finally(() => setLoading(false));
  }, [status]);

  const filters = (
    <div className="sp-filters">
      {STATUS_FILTERS.map((f) => (
        <button
          key={f.value}
          type="button"
          className={`sp-chip${status === f.value ? ' sp-chip--active' : ''}`}
          onClick={() => setStatus(f.value)}
        >
          {f.label}
        </button>
      ))}
    </div>
  );

  return (
    <SupplierPageLayout
      wide
      title="Purchase Orders"
      subtitle="Review, propose changes, and dispatch orders from your restaurant partners."
      icon="fa-file-text-o"
      breadcrumbs={[
        { label: 'Dashboard', to: '/supplier/dashboard' },
        { label: 'Purchase Orders' },
      ]}
      toolbar={filters}
    >
      {error && <div className="sp-alert sp-alert--error">{error}</div>}
      {loading ? (
        <div className="sp-loading">Loading purchase orders…</div>
      ) : orders.length === 0 ? (
        <SupplierEmptyState
          icon="fa-inbox"
          title="No orders in this view"
          message="Try another filter or wait for restaurants to send purchase orders."
        />
      ) : (
        <div className="sp-table-wrap">
          <table className="sp-table">
            <thead>
              <tr>
                <th>PO #</th>
                <th>Restaurant</th>
                <th>Status</th>
                <th>Total</th>
                <th className="sp-col-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((po) => (
                <tr key={`${po.restroId}-${po.id}`}>
                  <td>{po.poNumber}</td>
                  <td>{po.restaurantName || '—'}</td>
                  <td><SupplierStatusBadge status={po.status} /></td>
                  <td>{po.grandTotal != null ? `₹${po.grandTotal.toFixed(2)}` : '—'}</td>
                  <td className="sp-col-actions">
                    <Link to={`/supplier/orders/${po.restroId}/${po.id}`} className="sp-link">
                      Open <i className="fa fa-arrow-right" aria-hidden="true" />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </SupplierPageLayout>
  );
};

export default POList;
